import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

// Menu configuration
const menuItems = [
  { label: 'Dashboard', icon: 'dashboard', path: '/' },
  { label: 'Merchant Fee', icon: 'account_balance', path: '/merchant-fee' },
  { label: 'Donation', icon: 'volunteer_activism', path: '/donation' },
  { label: 'Subscription', icon: 'subscriptions', path: '/subscription' },
  { label: 'Ticker', icon: 'timeline', path: '/ticker' },
  { label: 'Programs', icon: 'school', path: '/programs' },
  { label: 'Events', icon: 'event', path: '/events' },
  { label: 'Services', icon: 'build', path: '/services' },
  { label: 'Public Profile', icon: 'person', path: '/public-profile' },
  { label: 'Prayer Times', icon: 'access_time', path: '/prayer-times' },
  { label: 'Advertisements', icon: 'campaign', path: '/advertisements' },
  { label: 'Reports', icon: 'bar_chart', path: '/reports' },
];

export default function DashboardLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const toggleSidebar = () => setCollapsed(prev => !prev);
  const location = useLocation();

  return (
    <div style={styles.dashboardLayout}>
      <aside
        style={{
          ...styles.sidebar,
          ...(collapsed ? styles.collapsedSidebar : {}),
        }}
      >
        <div style={styles.sidebarHeader}>
          {!collapsed && <span style={styles.sidebarLogo}>
            <img src={require('../../assets/logo/logo.png')} alt="AID" /></span>}

          {collapsed && <span style={styles.sidebarLogo}>
            <img src={require('../../assets/logo/logo-icon.png')} alt="AID" /></span>}


        </div>

        <nav style={styles.sidebarNav}>
          {collapsed &&
            <button style={styles.sidebarToggle} onClick={toggleSidebar}>
              <img src={require('../../assets/logo/expand.png')} alt="AID" />
            </button>
          }
          {menuItems.map(item => {
            const isActive = location.pathname === '/admin' + item.path;
            return(
            
            <Link key={item.path} to={'/admin' + item.path} className="menuNav" 
              style={{
                ...styles.navItem,
                ...(isActive ? styles.navItemActive : {}),
              }}>
              <span className="material-icons" style={styles.navIcon}>
                {item.icon}
              </span>
              {!collapsed && <span style={styles.navLabel}>{item.label}</span>}
            </Link>
          )})}
        </nav>
      </aside>

      <div style={styles.mainContent}>
        <header style={styles.header}>
          <button style={styles.mobileMenuBtn} onClick={toggleSidebar}>
            <span className="material-icons">menu</span>
          </button>
          <div></div>
          <div style={styles.headerRight}>
            <button style={styles.iconBtn}>
              <span className="material-icons">notifications</span>
            </button>
            <div style={styles.profile}>
              <span style={styles.avatarHolder}>
                <span style={styles.statusDot}></span>
                <img
                  src={require('../../assets/logo/Avatar.png')}
                  alt="User"
                  style={styles.profileImg}
                />
              </span>
              <div style={styles.profileInfo}>
                <div style={styles.profileName}>Olivia Rhye</div>
                <div style={styles.profileEmail}>olivia@untitledui.com</div>
              </div>
            </div>
          </div>
        </header>

        <main style={styles.contentArea}>{children}</main>
      </div>
    </div>
  );
}

// Inline styles moved to bottom
const styles = {
  dashboardLayout: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#EFEFEF',
  },
  sidebar: {
    backgroundColor: '#fff',
    borderRight: '1px solid #e0e0e0',
    width: '250px',
    transition: 'width 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
  },
  collapsedSidebar: {
    width: '70px',
  },
  sidebarHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '70px',
    padding: '0 16px',
    borderBottom: '1px solid #e0e0e0',
  },
  sidebarLogo: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    color: '#7c4dff',
  },
  sidebarToggle: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    marginLeft: 18
  },
  sidebarNav: {
    flex: 1,
    overflowY: 'auto',
    paddingTop: '8px',
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    margin: '12px',
    padding: '12px 16px',
    color: 'rgb(51, 51, 51)',
    textDecoration: 'none',
    transition: 'background 0.2s',
    borderRadius: '10px',
  },
  navItemActive: {
    background: 'rgb(246, 243, 255)'
  },
  navIcon: {
    fontSize: '20px',
  },
  navLabel: {
    marginLeft: '12px',
    fontSize: '0.95rem',
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '70px',
    padding: '0 24px',
    backgroundColor: '#fff',
    borderBottom: '1px solid #e0e0e0',
  },
  mobileMenuBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
  iconBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
  },
  profile: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '16px',
    position: 'relative',
  },
  avatarHolder: {
    position: 'relative'
  },
  statusDot: {
    width: '8px',
    height: '8px',
    backgroundColor: '#4caf50',
    borderRadius: '50%',
    position: 'absolute',
    right: '2px',
    bottom: '6px',
  },
  profileImg: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
  },
  profileInfo: {
    marginLeft: '8px',
  },
  profileName: {
    fontSize: '0.9rem',
    fontWeight: '500',
  },
  profileEmail: {
    fontSize: '0.75rem',
    color: '#666',
  },
  contentArea: {
    padding: '24px',
    // overflowY: 'auto',
  },
};